import { mdiDownload, mdiLoading } from "@mdi/js";
import { type JSX, splitProps } from "solid-js";
import { cn } from "~/util/utils";
import { ActionIcon, type ActionIconProps } from "../ui/icon";

export interface DownloadButtonProps
	extends Omit<ActionIconProps, "path">,
		Pick<JSX.ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
	loading: boolean;
}

export function DownloadButton(props: DownloadButtonProps) {
	const [local, other] = splitProps(props, ["class", "loading"]);

	return (
		<ActionIcon
			class={cn("min-w-10 min-h-10 max-h-10 max-w-10", local.class)}
			variant="outline"
			radius="xl"
			path={local.loading ? mdiLoading : mdiDownload}
			spin={local.loading}
			disabled={local.loading}
			{...other}
		/>
	);
}
